import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LoadingContextType {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

interface ProviderProps {
  children: ReactNode;
}

export const LoadingProvider: React.FC<ProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
      {isLoading && <FullScreenSpinner />}
    </LoadingContext.Provider>
  );
};

const FullScreenSpinner: React.FC = () => (
  <div style={styles.overlay}>
    <div className="loader2"></div>
    <div style={{ color: '#FFF', fontSize: '16px' }}>保存中</div>
  </div>
);

const styles: { overlay: React.CSSProperties } = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 9999,
  },
};
